<template>
  <td>
    <div
      v-show="date"
      class="single-date-picker__date"
      :class="{'single-date-picker__today': isToday, 
               'single-date-picker__selected': isSelected,
               'single-date-picker__disabled': !checkDay(date)}"
      @click="selectDate(checkDay(date))"
    >
      {{ date }}
    </div>
  </td>
</template>

<script>
export default {
  props: {
    date: {
      type: Number,
      default: () => 1
    },
    isToday: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    minDay: {
      type: Number,
      default: () => null
    },
    maxDay: {
      type: Number,
      default: () => null
    }
  },
  methods: {
    selectDate(available) {
      if(available){
        const component = this;
        component.$emit('selectDate', component.date);
      }
    },
    checkDay(day) {
      if(this.minDay !== null && this.maxDay !== null) {
        if (day >= this.minDay && day <= this.maxDay) {
          return true;
        }
      }
      return false;
    },
  }
}
</script>

<style lang="scss">
  .single-date-picker__date {
    font-size: 1rem;
    height: 2rem;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &.single-date-picker{
      &__today {
        border-radius: 50%;
        background-color: #eaeaea;
      }

      &:hover,
      &__selected {
        border-radius: 50%;
        background-color: #fd813d;
        color: #fff;
      }

      &__disabled{
        cursor: default;
        opacity: 0.5;
      }
    }
  }
</style>